var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 133,
    viewBox: "0 0 171 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.143 0H10.8573C4.86147 0 0 4.86115 0 10.857V122.143C0 128.139 4.86147 133 10.8573 133H160.143C166.139 133 171.001 128.139 171.001 122.143V10.857C171.001 4.86115 166.14 0 160.143 0ZM160.143 10.857V89.8184L138.746 70.3651C135.53 67.4418 130.585 67.5585 127.512 70.6339L105.857 92.2856L63.159 41.2841C59.9315 37.4298 54.0197 37.3919 50.7438 41.2L10.8573 87.5548V10.857H160.143ZM114.001 39.3571C114.001 31.111 120.683 24.4284 128.929 24.4284C137.175 24.4284 143.857 31.111 143.857 39.3571C143.857 47.6032 137.175 54.2855 128.929 54.2855C120.683 54.2858 114.001 47.6032 114.001 39.3571Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 85.5004,
    y1: 0,
    x2: 85.5004,
    y2: 133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2CEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95B6EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.49419f15cc5ac281ca0ae62621019c0a.svg";
export { ForwardRef as ReactComponent };